import React, {useRef, useState, useEffect} from 'react';
import {Form} from 'react-bootstrap';
import {PfButton} from '@profabric/react-components';
import {useStateWithCallbackLazy} from 'use-state-with-callback';

export default function ModalSetUser(props) {
  const [error, setError] = useState('');
  const [state, setState] = useStateWithCallbackLazy({
    ROW_NO: '',
    id: 0,
    USERNAME: '',
    PASSWORD: '',
    NAME: '',
    TEL: '',
    EMAIL: '',
    COUNTRY_CODE: '',
    COMPANY_NAME: '',
    COMPANY_ADDR: '',
    COMPANY_NUMBER: '',
    GENDER: '',
    COMPANY_BRANCH: '',
    COMPANY_POSTCODE: '',
    SUP_NAME: '',
    IS_ACTIVE: '',
    REG_DATE: '',
    CHANNEL: '',
    AGE_RANGE: ''
  });
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    console.log(props.item);
    setState({...props.item});
  }, [props.item]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const result = await props.onUpdate(
        {
          id: state.id,
          TEL: state.TEL,
          IS_ACTIVE: state.IS_ACTIVE,
          COUNTRY_CODE: state.COUNTRY_CODE
        }
      );
      setLoading(false);
    } catch (error) {}
  };

  return (
    <div>
      <Form>
        <div className="row">
          <Form.Group className="col-md-2">
            <Form.Label>ID</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.id}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-3">
          <Form.Label>Username</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.USERNAME}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-4">
          <Form.Label>Name</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.NAME}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-3">
          <Form.Label>Phone</Form.Label>
            <Form.Control
              size='sm'
              value={state.TEL}
              type="text"
              onChange={(e) => setState((prevState) => ({...prevState,TEL: e.target.value}))}
            />
          </Form.Group>
          <Form.Group className="col-md-5">
          <Form.Label>Email</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.EMAIL}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-6">
          <Form.Label>Company Name</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.COMPANY_NAME}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-1">
          <Form.Label>Area</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.COUNTRY_CODE}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-12">
          <Form.Label>Address</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.COMPANY_ADDR}
              as="textarea" rows={2}
            />
          </Form.Group>
          <Form.Group className="col-md-2">
          <Form.Label>Gender</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.GENDER}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-3">
          <Form.Label>Branch</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.COMPANY_BRANCH}
              type="text"
            />
          </Form.Group>

          <Form.Group className="col-md-4">
          <Form.Label>Sup. Name</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.SUP_NAME}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-3">
          <Form.Label>Reg. Date</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.REG_DATE}
              type="text"
            />
          </Form.Group>
          <Form.Group className="col-md-2">
          <Form.Label>Age</Form.Label>
            <Form.Control
              size='sm'
              disabled
              value={state.AGE_RANGE}
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
          </Form.Group>
        </div>
      </Form>
      <p className="text-danger">{error}</p>
      <PfButton
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleSubmit}
      >
        {'Save'}
      </PfButton>
    </div>
  );
}
